"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributionCategory = void 0;
exports.DistributionCategory = {
    Header: "header",
    Detail: "detail",
    Others: "others",
};
